var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserNri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9997,
    cy: 16.6667,
    r: 11.6667,
    fill: "#84DCC8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0039 13.6886C15.7854 11.257 13.9102 8.99123 12.9999 8.16228L12.4971 7.73221C14.5254 6.02709 17.1427 5 19.9999 5C22.5822 5 24.9685 5.83895 26.9012 7.25916C27.1743 8.08811 26.6542 9.82018 26.108 10.6491C25.9102 10.9494 25.4616 11.3221 24.9698 11.6755C23.8609 12.4722 22.4614 12.8663 21.7499 14.3333C21.5465 14.7527 21.5552 15.1626 21.6531 15.519C21.7234 15.7752 21.7683 16.0536 21.7691 16.326C21.7713 17.2067 20.8806 17.8429 19.9999 17.8333C17.7083 17.8083 16.2081 15.9615 16.0039 13.6886Z",
    fill: "#1177BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6762 23.9912C22.829 21.8188 26.6716 21.8188 26.6716 21.8188C30.6756 21.777 31.2164 19.3459 31.578 18.1172C30.9309 23.3454 26.8246 27.5015 21.6203 28.2244C21.2439 27.4323 20.798 25.6461 21.6762 23.9912Z",
    fill: "#1177BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0061 2.4984C30.4665 1.98399 31.2568 1.94022 31.7712 2.40062C35.5414 5.77502 37.917 10.6828 37.917 16.1437C37.917 25.7293 30.6024 33.6065 21.2503 34.498V35.4154H23.3337C24.024 35.4154 24.5837 35.975 24.5837 36.6654C24.5837 37.3557 24.024 37.9154 23.3337 37.9154H16.667C15.9766 37.9154 15.417 37.3557 15.417 36.6654C15.417 35.975 15.9766 35.4154 16.667 35.4154H18.7503V34.5679C13.5824 34.3671 8.95927 32.038 5.73559 28.4362C5.27518 27.9218 5.31895 27.1316 5.83336 26.6712C6.34777 26.2108 7.13801 26.2545 7.59842 26.769C10.5186 30.0317 14.7584 32.082 19.4787 32.082C28.2812 32.082 35.417 24.9462 35.417 16.1437C35.417 11.4234 33.3666 7.18367 30.1039 4.26346C29.5895 3.80305 29.5457 3.01281 30.0061 2.4984Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNri);
export default __webpack_public_path__ + "static/media/user-NRI.059d4aef0e6851342bf736fd16288b38.svg";
export { ForwardRef as ReactComponent };